// NPM
import React from 'react'

const TextField = ({ formField, value, required, onChange }) => {

  if(!formField) {
    return null
  }

  return (
  
    <div className="TextField field">
      <label className="label">
        { formField.name }
      </label>
      <div className="control">
        <input 
          className="input" 
          type="text" 
          placeholder={ formField.placeholder } 
          value={ value }
          onChange={ e => onChange(e.target.value) }
          required={ required }
        />
      </div>
    </div>
  )

}

export default TextField